<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>スタッフ等級管理</template>
      <template v-slot:annotation>
        {{ userName }}さんの等級履歴の設定ができます
      </template>
    </PageHeader>

    <v-row>
      <v-col cols="6" sm="6" md="4">
        <Button @click="edit()" color="info">追加</Button>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="等級履歴は見つかりませんでした。新規追加ボタンより等級履歴を設定してください。"
        >
          <template v-slot:[`item.DELETE`]="{ item }">
            <Button
              v-if="item.GRADE_LEAVE_DATE == null"
              color="secondary"
              @click="deleteStaffGradeConfirm(item)"
              :small="true"
              >削除</Button
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <Loader :loading="loading" />

    <StaffGradeEdit ref="edit" @edit="editUserGrade" />
    <DialogMessage ref="dialog" />
    <ConfirmDialog
      ref="confirm"
      title="等級情報編集"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="deleteUserGradeInfoRequest"
    >
    </ConfirmDialog>
  </v-container>
</template>

<script>
import StaffGradeEdit from '@/components/pages/Manages/StaffGradeSettingEdit.vue';
import axios from 'axios';
import config from '../../const.js';
import message from '../../message.js';
import { getSessionStorageItem, makeDateFormatStr } from '../../common.js';
import { Buffer } from 'buffer';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';

export default {
  components: {
    StaffGradeEdit,
    ConfirmDialog,
  },
  name: 'StaffGradeSetting',

  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'スタッフ管理',
          route: 'StaffSetting',
        },
        {
          name: 'スタッフ等級管理',
          route: 'StaffGradeSetting',
        },
      ],

      loading: false,
      confirm: false,
      confirmMessage: null,

      searchForm: {},
      items: [],
      userId: null,
      userName: null,
      organaizationKey: null,
      gradeId: null,
      gradeName: null,
      latestGradeJoinDate: '',

      headers: [
        {
          text: '等級名称',
          value: 'GRADE_NAME',
          width: '50%',
        },
        {
          text: '着任日',
          value: 'GRADE_JOIN_DATE',
        },
        {
          text: '離任日',
          value: 'GRADE_LEAVE_DATE',
        },
        {
          text: '',
          align: 'left',
          value: 'DELETE',
        },
      ],
    };
  },

  props: {
    staffId: {
      type: [String, String],
      required: true,
    },
  },

  created() {
    // 等級リストを取得
    // this.staffIdから該当のスタッフ名を取得
    // this.staffIdから等級履歴を取得しitemsにバインド
    this.userId = Buffer.from(this.staffId, 'base64').toString();
    this.getUserGrade();
  },

  methods: {
    editUserGrade() {
      // 等級情報取得
      this.getUserGrade();
    },
    async getUserGrade() {
      this.loading = true;

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      let vm = this;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/usergrade/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY +
            '/' +
            this.userId
        )
        .then((response) => {
          // ユーザ等級データ取得
          let isGrade = false;
          for (let i = 0; i < response.data.length; i++) {
            if (
              response.data[i].USER_NAME != null &&
              response.data[i].USER_NAME
            ) {
              // ユーザ名設定
              this.userName = response.data[i].USER_NAME;
            }
            if (
              response.data[i].GRADE_ID != null &&
              response.data[i].GRADE_ID
            ) {
              isGrade = true;
            }
          }
          if (isGrade) {
            // ユーザ等級データ設定
            vm.items = response.data;
            // ユーザ等級データ編集
            for (var cnt = 0; cnt < vm.items.length; cnt++) {
              // 等級着任日
              if (vm.items[cnt].GRADE_JOIN_DATE != null) {
                if (vm.items[cnt].GRADE_VALID_FLG == config.VALID_FLAG_ON) {
                  // 等級有効フラグが有効な日付を設定
                  this.latestGradeJoinDate = vm.items[cnt].GRADE_JOIN_DATE;
                }
                vm.items[cnt].GRADE_JOIN_DATE = makeDateFormatStr(
                  vm.items[cnt].GRADE_JOIN_DATE,
                  '/',
                  '/',
                  ''
                );
                // 等級離任日
                if (
                  vm.items[cnt].GRADE_LEAVE_DATE != config.END_WORKING_AT_INIT
                ) {
                  vm.items[cnt].GRADE_LEAVE_DATE = makeDateFormatStr(
                    vm.items[cnt].GRADE_LEAVE_DATE,
                    '/',
                    '/',
                    ''
                  );
                } else {
                  vm.items[cnt].GRADE_LEAVE_DATE = null;
                }
              }
            }
          } else {
            vm.items = [];
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    deleteStaffGradeConfirm(item) {
      // 確認ダイアログ表示
      this.gradeId = item.GRADE_ID;
      this.gradeName = item.GRADE_NAME;
      this.confirmMessage =
        '[' + this.gradeName + ']の等級管理情報を削除しますか？';
      this.$refs.confirm.open();
    },
    deleteUserGradeInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      //----- 等級情報削除リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/usergrade/delete',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,
            USER_ID: this.userId,
            GRADE_ID: this.gradeId,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = this.gradeName + message.MSG_INFO_GRADE_DELETE_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');

            // 等級情報取得
            this.getUserGrade();
          }
        })
        .catch((error) => {
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.gradeId = null;
          this.gradeName = null;

          // ローディング画像終了
          this.loading = false;
        });
    },
    edit(item = null) {
      this.$refs.edit.open(
        item,
        this.organaizationKey,
        this.userId,
        this.latestGradeJoinDate
      );
    },
    closeEdit() {
      this.getUserGrade();
    },
  },
};
</script>
